import { render } from "./CodeTabletFormComponentDetails.vue?vue&type=template&id=09fc8a83"
import script from "./CodeTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./CodeTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__